import React, { useEffect, useMemo } from 'react';
import { MapMarker } from './MapMarker';
export function MapMarkerCollection({ children, map, onBoundsKnown, onMarkerSelected, }) {
    // Memoize the array of valid MapMarker children.
    const markersArray = useMemo(() => React.Children.toArray(children).filter((child) => React.isValidElement(child) && child.type === MapMarker), [children]);
    // Compute bounds based on all marker coordinates.
    const bounds = useMemo(() => {
        const b = new google.maps.LatLngBounds();
        markersArray.forEach((marker) => {
            b.extend(marker.props.coordinates);
        });
        return b;
    }, [markersArray]);
    // Notify once the bounds are known and there are markers present.
    useEffect(() => {
        if (markersArray.length > 0) {
            onBoundsKnown === null || onBoundsKnown === void 0 ? void 0 : onBoundsKnown(bounds);
        }
    }, [onBoundsKnown, bounds, markersArray.length]);
    if (markersArray.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null, markersArray.map((marker) => React.cloneElement(marker, {
        map,
        onSelected: onMarkerSelected,
        key: marker.props.estabId,
    }))));
}
